import {
  withMethods,
  signalStoreFeature,
  WritableStateSource,
} from '@ngrx/signals';
import { exhaustMap, pipe, tap } from 'rxjs';
import { tapResponse } from '@ngrx/operators';
import { User, UserCredential } from 'firebase/auth';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { FirebaseAuthOutput } from './utils/firebase-auth';
import { mapFirebaseAuthErrorToMessage } from './utils/auth-error';
import { withCustomCallState } from '../utils/with-custom-call-state.feature';

type RegisterDeps = WritableStateSource<FirebaseAuthOutput['state']> &
  Pick<
    FirebaseAuthOutput['methods'],
    '_createAccount' | '_sendEmailVerification'
  > &
  Pick<FirebaseAuthOutput['props'], '_getUserSession$'>;

export function withRegisterResources<T extends RegisterDeps>(store: T) {
  return signalStoreFeature(
    withCustomCallState('register'),

    withMethods((innerStore) => ({
      createAccount: rxMethod<{ user: string; pass: string }>(
        pipe(
          tap(() => innerStore._registerSetLoading()),

          exhaustMap((creds) =>
            store._createAccount(creds).pipe(
              exhaustMap((cred: UserCredential) =>
                store._sendEmailVerification(cred.user as User),
              ),
              tapResponse({
                next: () => innerStore._registerSetSuccess(),
                error: (err: unknown) =>
                  innerStore._registerSetError(
                    mapFirebaseAuthErrorToMessage(err),
                  ),
              }),
            ),
          ),
        ),
      ),
    })),
  );
}
